import { Type } from '@angular/core';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { CommonModule } from '@angular/common';

import { TdMediaService } from './services/media.service';
import { TdMediaToggleDirective } from './directives/media-toggle.directive';

const /** @type {?} */ TD_MEDIA: Type<any>[] = [
  TdMediaToggleDirective,
];

export { TdMediaService, TdMediaToggleDirective };
export class QuiverMediaModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
  ],
  declarations: [
    TD_MEDIA,
  ],
  exports: [
    TD_MEDIA,
  ],
  providers: [
    TdMediaService,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverMediaModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverMediaModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverMediaModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
